const style = {
    content: {
        margin: '0 auto',
        position: 'relative',
        top: '14%'
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)'
    }
}

export default style